import { v4 as uuid } from 'uuid';

const PillsSkeleton = () => {
  const generateTabs = () => {
    const list = Array(5).fill('.');

    return list.map(list => {
      return (
        <div key={uuid()} className={'itemHeader'}>
          <div className="fullSkeleton" />
        </div>
      );
    });
  };
  const generateProperties = () => {
    return (
      <>
        <div className="containerSelect">
          <div className="fullSkeleton" />
        </div>
        <div className="containerSelect">
          <div className="fullSkeleton" />
        </div>
        <div className="containerSelect">
          <div className="fullSkeleton" />
        </div>
      </>
    );
  };
  return (
    <>
      <div className="generalTabsContainer">
        <div className="headerTabs">{generateTabs()}</div>
        <div className="containerProperties">
          <div className="h-6 w-44">
            <div className="fullSkeleton" />
          </div>
          <div className="containterProperties">
            <div className="h-5 w-10 mr-2">
              <div className="fullSkeleton" />
            </div>
            <div className="h-5 w-10 mr-2">
              <div className="fullSkeleton" />
            </div>
            {generateProperties()}
          </div>
        </div>
      </div>
    </>
  );
};
export default PillsSkeleton;
